// extracted by mini-css-extract-plugin
export default {"menu":"ActionsPopup_menu__rN13g","menuItem":"ActionsPopup_menuItem__+2-3s"};